import {
  COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST,
  COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST_SUCCESS,
  COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST_FAILURE,
  COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST,
  COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST_SUCCESS,
  COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST_FAILURE,
  COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST,
  COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST_SUCCESS,
  COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST_FAILURE,
  COMPLIANCE_INTERNAL_BLOCK_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const complianceInternalBlockReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST:
    case COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST:
    case COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST_SUCCESS:
    case COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST_SUCCESS:
    case COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case COMPLIANCE_INTERNAL_BLOCK_ADD_REQUEST_FAILURE:
    case COMPLIANCE_INTERNAL_BLOCK_UPDATE_REQUEST_FAILURE:
    case COMPLIANCE_INTERNAL_BLOCK_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {},
      });

    case COMPLIANCE_INTERNAL_BLOCK_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
        payload: [],
        pagination: {},
      });

    default:
      return state;
  }
};

export default complianceInternalBlockReducer;
